import { render, staticRenderFns } from "./ActiveChecksEditConfigPage.vue?vue&type=template&id=753f1bb4"
import script from "./ActiveChecksEditConfigPage.vue?vue&type=script&lang=js"
export * from "./ActiveChecksEditConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports